export const momentumConstants = {
  STORE_MOMENTUM_REQUEST: 'STORE_MOMENTUM_REQUEST',
  STORE_MOMENTUM_SUCCESS: 'STORE_MOMENTUM_SUCCESS',
  STORE_MOMENTUM_FAILURE: 'STORE_MOMENTUM_FAILURE',

  UPDATE_MOMENTUM_REQUEST: 'UPDATE_MOMENTUM_REQUEST',
  UPDATE_MOMENTUM_SUCCESS: 'UPDATE_MOMENTUM_SUCCESS',
  UPDATE_MOMENTUM_FAILURE: 'UPDATE_MOMENTUM_FAILURE',

  LIST_FILTERS_REQUEST: 'LIST_FILTERS_REQUEST',
  LIST_FILTERS_SUCCESS: 'LIST_FILTERS_SUCCESS',
  LIST_FILTERS_FAILURE: 'LIST_FILTERS_FAILURE',

  LIST_CUSTOM_FILTERS_REQUEST: 'LIST_CUSTOM_FILTERS_REQUEST',
  LIST_CUSTOM_FILTERS_SUCCESS: 'LIST_CUSTOM_FILTERS_SUCCESS',
  LIST_CUSTOM_FILTERS_FAILURE: 'LIST_CUSTOM_FILTERS_FAILURE',

  LIST_MOMENTUM_BY_ID_REQUEST: 'LIST_MOMENTUM_BY_ID_REQUEST',
  LIST_MOMENTUM_BY_ID_SUCCESS: 'LIST_MOMENTUM_BY_ID_SUCCESS',
  LIST_MOMENTUM_BY_ID_FAILURE: 'LIST_MOMENTUM_BY_ID_FAILURE',

  LIST_MOMENTUMS_REQUEST: 'LIST_MOMENTUMS_REQUEST',
  LIST_MOMENTUMS_SUCCESS: 'LIST_MOMENTUMS_SUCCESS',
  LIST_MOMENTUMS_FAILURE: 'LIST_MOMENTUMS_FAILURE',

  LIST_CHANNELS_REQUEST: 'LIST_CHANNELS_REQUEST',
  LIST_CHANNELS_SUCCESS: 'LIST_CHANNELS_SUCCESS',
  LIST_CHANNELS_FAILURE: 'LIST_CHANNELS_FAILURE',

  REMOVE_MOMENTUM_REQUEST: 'REMOVE_MOMENTUM_REQUEST',
  REMOVE_MOMENTUM_SUCCESS: 'REMOVE_MOMENTUM_SUCCESS',
  REMOVE_MOMENTUM_FAILURE: 'REMOVE_MOMENTUM_FAILURE'
}